import React from "react";

const AssignmentRelease = () => {
    return (
        <div className="mb-6">
            <p className="text-justify font-medium text-base text-black  leading-relaxed">
                I, the undersigned, certify that I (or my Dependent) have
                insurance coverage with the carrier(s) given to the front desk
                staff and assign directly to Retina Specialty Institute all
                insurance benefits, if any, otherwise payable to me for
                services rendered. I understand that I am financially
                responsible for all charges whether or not paid by insurance.
                <br />
                <br />
                In Medicare assigned cases, the physician or supplier agrees
                to accept the charge determination of the Medicare carrier as
                the full charge, and the patient is responsible only for the
                deductible, coinsurance, and non-covered services. I hereby
                authorize the doctor to release all information necessary to
                secure payment of benefits.
                <br />
                <br />
                If your insurance is an HMO, your HMO requires that your
                primary care doctor provide a referral to the physician who is
                providing your ophthalmology care. It is your responsibility
                to obtain authorization in advance of your appointment (at
                least 24 hrs.). Your doctor may mail/fax it to our office or
                you may bring it to your visit. Contact us if you require any
                assistance in obtaining the authorization. We will be happy to
                help in any way possible. If an authorization is not obtained
                from your HMO prior to the delivery of care, we will expect
                you to accept financial responsibility for any charges. You
                will be sent a bill from the billing office for physician
                services provided to you.
                <br />
                <br />I have read the statement above and I understand that I
                will be billed and am responsible for payment for the
                professional and facility fees for services provided to me in
                the event that my HMO does not authorize these services.
            </p>
        </div>
    );
};

export default AssignmentRelease;
